import React from 'react';
import Loader from '@gr-monorepo/common/public/ui/Loader';
import { Wrapper } from './elements';

const LoaderComponent = (_props?: { color?: string }) => (
  <Wrapper data-testid="loader">
    <Loader size={32} />
  </Wrapper>
);

export default LoaderComponent;
